
<div class="flex-box">
  <div class="flex-heading">
    <div class="list-header col-xs-12"><span class="pR20">Regimens</span>
      <div class="pull-right"><i class="fa fa-plus-square-o pointer" routerLink="/products/regimens/new"></i></div>
    </div>
  </div>
  <div class="flex-content scroll-x">
    <div class="list-view">
      <div class="list-sidebar">
        <div class="header">
          <div class="title">Filters</div>
          <button class="btn-xxs btn-primary-outline" (click)="resetFilters()">Reset</button>
        </div>
        <div class="content" style="display: block; overflow-y: auto;">
          <div class="flex mt-3">
            <label class="mr-3">Auto Refresh</label>
            <label data-testid="auto-refresh-switch" class="i-switch i-switch-sm bg-success">
              <input type="checkbox" [(ngModel)]="autoRefresh" (ngModelChange)="toggleAutoRefresh()" name="autoRefresh"/><i></i>
            </label>
          </div>
          <div class="flex bdr-top mt-2 pt-2">
            <label class="mr-3">Active</label>
            <label class="i-switch i-switch-sm bg-success">
              <input type="checkbox" [(ngModel)]="activeRegimen" (ngModelChange)="toggleActiveRegimen()" name="activeRegimen"/><i></i>
            </label>
          </div>
          <div class="mt-3">
            <label>Search</label>
            <input class="w100" placeholder="Title, Id, Class, SkinType" (change)="reset()" [(ngModel)]="searchKey"/>
          </div>
          <div class="mt-3">
            <label>Products</label>
            <div *ngIf="selectedProducts.length" class="mb-2">
              <div class="badge m-1 ml-0" *ngFor="let p of selectedProducts; let i = index;">
                <span class="pr-2">{{p.name}}</span>
                <i class="fa fa-times pointer" (click)="removeProduct(i)"></i>
              </div>
            </div>
            <input class="w100" type="text" placeholder="Search product..." autocomplete="off"
              matInput [formControl]="productAutoComplete" [matAutocomplete]="productAuto"/>
            <mat-autocomplete #productAuto="matAutocomplete">
              <mat-option *ngFor="let option of productOptions | async" [value]="option.name"
                (onSelectionChange)="selectProduct(option)">{{option.name}}</mat-option>
            </mat-autocomplete>
          </div>
          <div class="mt-3">
            <label>Gender</label>
            <select class="w100 form-control" [(ngModel)]="extraRegimenInfoFilters.gender" (ngModelChange)="reset()">
              <option value="">All</option>
              <option *ngFor="let option of genderOptions" [value]="option.value">{{option.display}}</option>
            </select>
          </div>
          <div class="mt-3">
            <label>Teenager</label>
            <select class="w100 form-control" [(ngModel)]="teenagerFilter" (ngModelChange)="reset()">
              <option value="">All</option>
              <option value="YES">Yes</option>
              <option value="NO">No</option>
            </select>
          </div>
          <div class="mt-3">
            <label>Pregnancy</label>
            <select class="w100 form-control" [(ngModel)]="pregnancyFilter" (ngModelChange)="reset()">
              <option value="">All</option>
              <option value="NOT_PREGNANT">Not Pregnant</option>
              <option value="PREG_BF">Preg/BF</option>
            </select>
          </div>
          <div class="mt-3">
            <label>Hormonal Impact</label>
            <select class="w100 form-control" [(ngModel)]="extraRegimenInfoFilters.hormonalImpact" (ngModelChange)="reset()">
              <option value="">All</option>
              <option *ngFor="let option of hormonalImpactOptions" [value]="option.value">{{option.display}}</option>
            </select>
          </div>
          <div class="mt-3">
            <label>Sensitive Skin</label>
            <select class="w100 form-control" [(ngModel)]="extraRegimenInfoFilters.sensitiveSkin" (ngModelChange)="reset()">
              <option value="">All</option>
              <option *ngFor="let option of sensitiveSkinOptions" [value]="option.value">{{option.display}}</option>
            </select>
          </div>
          <div class="mt-3 mb-3">
            <label>Steroid Abuse</label>
            <select class="w100 form-control" [(ngModel)]="extraRegimenInfoFilters.steroidAbuse" (ngModelChange)="reset()">
              <option value="">All</option>
              <option *ngFor="let option of steroidAbuseOptions" [value]="option.value">{{option.display}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="list-content">
        <ag-grid-angular class="ag-theme-balham" style="height: 100%;" [columnDefs]="columnDefs" [components]="components" [rowBuffer]="0" [rowModelType]="ui.grid.rowModelType" [paginationPageSize]="ui.grid.pageSize" [cacheBlockSize]="ui.grid.pageSize" [cacheOverflowSize]="1" [maxConcurrentDatasourceRequests]="1" [infiniteInitialRowCount]="1" [maxBlocksInCache]="10" (gridReady)="onGridReady($event)"></ag-grid-angular>
      </div>
    </div>
  </div>
</div>